import { createTheme } from '@mui/material/styles';

// Shared theme for the public registration flow (Header, Form, and every
// subForm) - a warm, friendly palette instead of MUI's default stark blue,
// applied once here so every button/card/stepper/checkbox picks it up
// automatically.
const theme = createTheme({
  palette: {
    primary: { main: '#3A6EA5' },
    secondary: { main: '#EF8354' },
    background: { default: '#FAF9F6', paper: '#FFFFFF' },
  },
  shape: { borderRadius: 12 },
  typography: {
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 16 },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: { color: '#3A6EA5' },
      },
    },
  },
});

export default theme;
